export default __webpack_public_path__ + "static/media/8_4.e804d951.jpg";